/**
 * Persists the referral brand so it survives a refresh and the post-lookup pages, whose paths
 * (/referral/:complaintId/...) carry no brand segment.
 *
 * sessionStorage rather than localStorage, for the same reason as lib/remedyDraft: it survives
 * reload and in-app navigation but is discarded when the tab closes, so a brand from an earlier
 * visit can never leak into a later one.
 */

import { safeStorageGet, safeStorageSet } from 'lib/safeStorage';
import { ReferralBrand }                  from './brand';

const STORAGE_KEY = 'referralBrand';

export function loadReferralBrand(): ReferralBrand | null {
  const stored = safeStorageGet('session', STORAGE_KEY);
  return stored === 'energy' || stored === 'communications' ? stored : null;
}

export function saveReferralBrand(brand: ReferralBrand): void {
  safeStorageSet('session', STORAGE_KEY, brand);
}
